import React, { useCallback, useEffect, useMemo, useState } from 'react';
import _sumBy from 'lodash/sumBy';

// Components
import * as S from './Styled';
import Item from './Item';
import QueueAnim from 'rc-queue-anim';
import { useDispatch, useSelector } from 'react-redux';
import {
  addToCart,
  removeFromCart,
  addPartToCart,
  removePartFromCart,
  setItemCount,
} from '../../actions';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isDivisible } from '../../utils/cart';
import { Button } from '../Button';
import { SingleProductModal } from '../ProductModal';
import _filter from 'lodash/filter';
import _find from 'lodash/find';
import { useMediaQuery } from 'react-responsive';

const Cart = ({ onPreviewItem, setCartModal }) => {
  const dispatch = useDispatch();
  const cartItems = useSelector(state => state.cart.items);
  const removeItem = id => dispatch(removeFromCart({ id }, true));
  const { t } = useTranslation();
  const history = useHistory();
  const [viewModal, setViewModal] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);
  const isMob = useMediaQuery({ query: '(max-width: 767px)' });

  useEffect(() => {
    onPreviewItem(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems]);

  const getPrice = useCallback(item => item.in_cart * item.online_price, []);

  const getPartialPrice = useCallback(
    item =>
      (item.in_cart / item.pack_info.quantity_unit_in_pack) * item.online_price,
    []
  );
  const getItem = useCallback(
    item =>
      isDivisible(item.pack_info) ? getPartialPrice(item) : getPrice(item),
    [getPrice, getPartialPrice]
  );

  const total = useMemo(() => _sumBy(cartItems, getItem).toFixed(2), [
    cartItems,
    getItem,
  ]);

  const notAdded = useMemo(() => _filter(cartItems, i => i.in_cart === 0), [
    cartItems,
  ]);

  return (
    <>
      <S.Cart>
        <S.Title>{t('labels.shopping_cart')}</S.Title>
        <S.CartContent>
          <div className="animated" key="a">
            <QueueAnim
              delay={200}
              animConfig={[
                { opacity: [1, 0], translateY: [0, 50] },
                { opacity: [1, 0], translateY: [0, -50] },
              ]}
              leaveReverse
              appear={false}
            >
              {cartItems.map(item => {
                const payload = {
                  ...item,
                  onRemove: removeItem,
                  addOne: () => dispatch(addToCart({ id: item.id })),
                  removeOne: () => dispatch(removeFromCart({ id: item.id })),
                  addOnePart: () => dispatch(addPartToCart({ id: item.id })),
                  removeOnePart: () =>
                    dispatch(removePartFromCart({ id: item.id })),
                  changeCount: value => dispatch(setItemCount(item.id, value)),
                  onShow: id => {
                    setViewModal(true);
                    setPreviewItem(id);
                  },
                  notAdded: _find(notAdded, i => i.id === item.id) ?? false,
                };

                return (
                  <S.CartRow key={item.id}>
                    <Item product={payload} />
                  </S.CartRow>
                );
              })}
            </QueueAnim>
          </div>

          <S.Panel>
            <Button
              type="cart"
              size="large"
              htmlType="button"
              onClick={() => {
                setCartModal(false);
                history.push('/order');
              }}
              disabled={parseInt(total) <= 0 || notAdded.length}
            >
              {t('buttons.order')}
            </Button>
            <S.AmountContainer>
              <S.Amount>{t('labels.total')}</S.Amount>
              <S.Total>
                {total > 0 ? t('labels.of') : null}{' '}
                <S.Value>{total > 0 ? total : 0}</S.Value> ₴
              </S.Total>
            </S.AmountContainer>
          </S.Panel>
        </S.CartContent>
      </S.Cart>

      <SingleProductModal
        visible={viewModal}
        onOk={() => console.log('onOk')}
        onCancel={() => {
          setViewModal(false);
          setPreviewItem(null);
        }}
        initialItem={previewItem}
        onAddToCart={() => {}}
      />
    </>
  );
};

export default Cart;
